import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DateService } from 'src/app/common/date.service';
import { FiltersComponent } from 'src/app/common/filters.component';

import { Data2Service } from 'src/app/common/data2.service';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { DataBagService } from '../../../../common/data-bag.service';
import { Product } from '../../../../reservation/reservation.model';
import {
	concat,
	debounceTime,
	distinctUntilChanged,
	filter,
	Observable,
	Observer,
	of,
	Subject,
	Subscription,
	switchMap,
	tap,
} from 'rxjs';

@Component({
	selector: 'app-group-offer-price-filters',
	templateUrl: './group-offer-price-filters.component.html',
	styleUrls: ['./group-offer-price-filters.component.css'],
})
export class GroupOfferPriceFiltersComponent extends FiltersComponent implements OnInit, OnDestroy {
	@Input() product: any;
	@Input() date_range: Date;
	@Input() status: any;
	@Input() editable: boolean;
	@Input() offerTerm;

	constructor(
		protected api: Data2Service,
		protected route: ActivatedRoute,
		protected router: Router,
		protected infobox: InfoboxService,
		private readonly bag: DataBagService,
	) {
		super(api, route, router);
	}

	filters = {
		product: null,
		date_range: null,
		nights_stay: null,
		term_price_status: null,
	};

	protected filtersDefinition = {
		product: {
			type: 'number',
			isArray: true,
		},
	};

	statusSet = [
		{ value: 'P', name: 'Opublikowany' },
		{ value: 'W', name: 'Oczekujący' },
		{ value: 'E', name: 'Błąd' },
	];

	date = {
		lower: null,
		upper: null,
	};

	nights;

	dateService = new DateService();

	private defaultProducts: Product[] = [];
	private productSubscription: Subscription;
	protected products$: Observable<any>;
	protected productLoading = false;
	protected productsInput$ = new Subject<string>();
	protected minLengthTerm = 3;

	ngOnInit() {
		super.ngOnInit();
		this.productSubscription = this.getProducts(`id__in=${this.filters.product ?? ''}`).subscribe((products) => {
			if (products) {
				this.defaultProducts = products;
				this.loadProducts();
			}
		});
	}

	updateDate() {
		if (this.date.lower && this.date.upper) {
			this.filters.date_range = `${
				this.dateService.datetimeWithTimezone(this.date.lower).date
			},${this.dateService.datetimeWithTimezone(this.date.upper).date}`;
		}
	}

	updateNights() {
		this.filters.nights_stay = this.nights + 1;
	}

	filtersClear() {
		for (const key in this.filters) {
			if (Array.isArray(this.filters[key])) {
				this.filters[key] = [];
				continue;
			}
			this.filters[key] = null;
		}
		this.date.lower = null;
		this.date.upper = null;
		this.nights = null;
		this.filtersSave();
	}

	checkEdit() {
		const isEdit = this.offerTerm.filter((item) => item.termPrice && item.termPrice.status == 'D');
		if (isEdit.length > 0) {
			this.infobox.warning('Opublikuj edytowane terminy, aby filtrować!');
			return;
		}
		this.filtersSave();
	}

	private loadProducts() {
		this.products$ = concat(
			of(this.defaultProducts),
			this.productsInput$.pipe(
				filter((res) => {
					return res !== null && res.length >= this.minLengthTerm;
				}),
				distinctUntilChanged(),
				debounceTime(800),
				tap(() => (this.productLoading = true)),
				switchMap((name) => {
					return this.getProducts(`name__icontains=${name}`).pipe(tap(() => (this.productLoading = false)));
				}),
			),
		);
	}

	private getProducts(params: string) {
		return new Observable((observer: Observer<Product[]>) => {
			this.bag.get(`/product/?${params}`, (result, error) => {
				if (error) {
					observer.error(error);
				} else {
					observer.next(result.results);
					observer.complete();
				}
			});
		});
	}

	ngOnDestroy() {
		super.ngOnDestroy();
		this.productSubscription.unsubscribe();
	}
}
